module.exports = __webpack_public_path__ + "img/robot.6a1a7cd1.png";